import AgreementsSection from "@/components/agreements-section";
import ExamsFaqSection from "@/components/exams/exams-faq-section";
import Hero from "@/components/hero";
import { LocationsSection } from "@/components/locations-section";
import ResultsSection from "@/components/results-section";
import SeoMeta from "@/components/seo-meta";
import { useLayout } from "@/contexts/layout-context";
import { buildMedicalBusinessJsonLd } from "@/lib/seo-data";
import rawData from "../../src/data/setup.json";
import type { Data } from "../types/data";

export default function HomePage() {
	const data: Data = rawData;

	const { selectedLayout, isShowcaseMode } = useLayout();

	// Determina qual layout usar: se showcase mode, usa o selecionado; senão usa o do setup
	const layoutToUse = isShowcaseMode ? selectedLayout : data.layout;

	switch (layoutToUse) {
		case 1:
			return (
				<>
					<SeoMeta
						title={`${data.cliente.nome} | Laboratório`}
						description={data["area-inicial"].texto}
						canonicalPath="/"
						jsonLd={buildMedicalBusinessJsonLd(data)}
					/>
					<Hero data={data} />
					<LocationsSection
						headquarters={data.cliente}
						branches={data.cliente.filiais}
					/>
				</>
			);
		case 2:
			return (
				<>
					<SeoMeta
						title={`${data.cliente.nome} | Laboratório`}
						description={data["area-inicial"].texto}
						canonicalPath="/"
						jsonLd={buildMedicalBusinessJsonLd(data)}
					/>
					<Hero data={data} />
					<LocationsSection
						headquarters={data.cliente}
						branches={data.cliente.filiais}
					/>
					{data["area-resultados"].ativa && <ResultsSection data={data} />}
					{data["area-exames"].ativa && <ExamsFaqSection data={data} />}
					{data["area-convenios"].ativa && <AgreementsSection data={data} />}
				</>
			);
		case 3:
			return <div>Children do layout 03</div>;
		default:
			return <div>Layout não encontrado</div>;
	}
}
